import cookies from './util.cookies'
import localStorage from './util.localStorage'
// import db from './util.db'
// import log from './util.log'
// import dayjs from 'dayjs'
// import filterParams from './util.params'

const util = {
   cookies,
   localStorage,
   // db,
   // log,
   // filterParams
}

/**
 * @description 更新标题
 * @param {String} titleText 标题
 */
util.title = function (titleText) {
   const processTitle = process.env.VUE_APP_TITLE || 'Cloud Phone'
   // window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
   window.document.title = `${processTitle}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
   var a = document.createElement('a')
   a.setAttribute('href', url)
   a.setAttribute('target', '_blank')
   a.setAttribute('id', 'tccc-link-temp')
   document.body.appendChild(a)
   a.click()
   document.body.removeChild(document.getElementById('tccc-link-temp'))
}
/**
 * @description 校验是否为租户模式。租户模式把域名替换成 域名 加端口
 */
util.baseURL = function () {
   // var baseURL = process.env.VUE_APP_API
   // if (
   //    window.pluginsAll &&
   //    window.pluginsAll.indexOf('dvadmin-tenant-web') !== -1
   // ) {
   //    // document.domain
   //    var host = baseURL.split('/')[2]
   //    var prot = host.split(':')[1] || 80
   //    host = document.domain + ':' + prot
   //    baseURL =
   //       baseURL.split('/')[0] +
   //       '//' +
   //       baseURL.split('/')[1] +
   //       host +
   //       '/' +
   //       (baseURL.split('/')[3] || '')
   // }
   // if (!baseURL.endsWith('/')) {
   //    baseURL += '/'
   // }
   // return baseURL
}
/**
 * 自动生成ID
 */
util.autoCreateCode = function () {
   return (
      dayjs().format('YYYYMMDDHHmmssms') + Math.round(Math.random() * 80 + 20)
   )
}
/**
 * 自动生成短 ID
 */
util.autoShortCreateCode = function () {
   var Num = ''
   for (var i = 0; i < 4; i++) {
      Num += Math.floor(Math.random() * 10)
   }
   return dayjs().format('YYMMDD') + Num
}

/**
 * 生产随机字符串
 */
util.randomString = function (e) {
   e = e || 32
   var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
   var a = t.length
   var n = ''
   for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
   return n
}

//获取当前时区
util.getTimeZone = function () {
   return String(0 - new Date().getTimezoneOffset() / 60)
}

util.convertCallObj = function (d, info) {
   var call_name = d.um_users__username + '' //um 打电话的人 cm 接电话的人

   // 查询用的电话号码（原始逻辑，用于API查询）
   var query_phone = d.tccc_call_log_static_rel__caller
   if (d.um_users__user_id == info.userid) {
      call_name = d.cm_contact__contact_name + ''
      query_phone = d.tccc_call_log_static_rel__callee
   }

   // 显示用的电话号码（智能选择逻辑，用于页面显示和拨打）
   var display_phone = ''
   if (d.um_users__user_id == info.userid) {
      //如果是自己打出去的
      display_phone = d.tccc_seats__callee_ch_soft_tele ||
                     d.maybe_callee_extension ||
                     d.tccc_call_log_static_rel__callee
   } else {
      //如果是打进来的
      display_phone = d.tccc_seats__caller_ch_soft_tele ||
                     d.maybe_caller_extension ||
                     d.tccc_call_log_static_rel__caller
   }

   // 去除国际区号前缀
   if (display_phone && display_phone.length > 0) {
      var _prefix = display_phone.substr(0, 4)
      if (['0086', '0085'].indexOf(_prefix) != -1) {
         display_phone = display_phone.substr(4)
      }
   }

   return {
      call_name,
      _call_full_phone: query_phone,  // 用于查询
      display_phone: display_phone,   // 用于显示和拨打
   }
}

/**
 * @author: wangyanhui
 * @description: 判断是否为微信环境
 * @param {*}
 * @return {*}
 */
util.isWeChatWorkEnv = () => {
   const userAgent = navigator.userAgent.toLowerCase()
   return /micromessenger/i.test(userAgent)
}

util.isPC = () => {
   var userAgent = navigator.userAgent.toLowerCase()
   var platform = navigator.platform.toLowerCase()
   var macosPlatforms = ['macintosh', 'macintel', 'macppc', 'mac68k']
   var windowsPlatforms = ['win32', 'win64', 'windows', 'winCE']
   var iosPlatforms = ['iPhone', 'iPad', 'iPod']
   var os = null

   if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS'
   } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS'
   } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows'
   } else if (/android/.test(userAgent)) {
      os = 'Android'
   } else if (!os && /linux/.test(platform)) {
      os = 'Linux'
   }

   // If the device is running iOS or Android, it's not a PC
   if (os === 'iOS' || os === 'Android') {
      return false
   }

   // If the device has a touch screen, it's likely not a PC
   if (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
   ) {
      return false
   }

   // If all checks fail, we assume it's a PC
   return true
}

// 定义userLoginCache对象
const userLoginCache = {
   // 缓存键
   LOGIN_INFO_KEY: 'cached_login_info',
   // 缓存时间键
   LOGIN_INFO_TIME_KEY: 'cached_login_info_time',
   // 缓存有效期(15天)，单位毫秒
   CACHE_DURATION: 15 * 24 * 60 * 60 * 1000,
   
   // 需要明确引用util.localStorage，而不是this.localStorage
   saveLoginInfo(loginInfo) {
     if (!loginInfo || !loginInfo.userid) return;
     
     try {
       // 添加时间戳
       const cacheData = {
         ...loginInfo,
         timestamp: Date.now()
       };
       
       // 存储到localStorage，使用util.localStorage而不是this.localStorage
       util.localStorage.set(this.LOGIN_INFO_KEY, JSON.stringify(cacheData));
       util.localStorage.set(this.LOGIN_INFO_TIME_KEY, Date.now().toString());
       
       console.log('用户登录信息已缓存，将在15天后过期');
     } catch (error) {
       console.error('缓存用户登录信息失败:', error);
     }
   },
   
   getLoginInfo() {
     try {
       // 获取缓存时间，使用util.localStorage
       const cacheTimeStr = util.localStorage.get(this.LOGIN_INFO_TIME_KEY);
       if (!cacheTimeStr) return null;
       
       const cacheTime = parseInt(cacheTimeStr);
       const now = Date.now();
       
       // 检查是否过期
       if (now - cacheTime > this.CACHE_DURATION) {
         console.log('用户登录信息缓存已过期');
         this.clearLoginInfo();
         return null;
       }
       
       // 获取缓存数据，使用util.localStorage
       const cacheDataStr = util.localStorage.get(this.LOGIN_INFO_KEY);
       if (!cacheDataStr) return null;
       
       const cacheData = JSON.parse(cacheDataStr);
       console.log('使用缓存的用户登录信息，剩余有效期:', 
         Math.floor((this.CACHE_DURATION - (now - cacheTime)) / (24 * 60 * 60 * 1000)), '天');
       
       return cacheData;
     } catch (error) {
       console.error('获取用户登录信息缓存失败:', error);
       return null;
     }
   },
   
   clearLoginInfo() {
     // 使用util.localStorage
     util.localStorage.remove(this.LOGIN_INFO_KEY);
     util.localStorage.remove(this.LOGIN_INFO_TIME_KEY);
     console.log('用户登录信息缓存已清除');
   },
   
   hasValidCache() {
     try {
       // 使用util.localStorage
       const cacheTimeStr = util.localStorage.get(this.LOGIN_INFO_TIME_KEY);
       if (!cacheTimeStr) return false;
       
       const cacheTime = parseInt(cacheTimeStr);
       const now = Date.now();
       
       // 检查是否过期
       if (now - cacheTime > this.CACHE_DURATION) return false;
       
       // 检查是否有数据，使用util.localStorage
       const cacheDataStr = util.localStorage.get(this.LOGIN_INFO_KEY);
       return !!cacheDataStr;
     } catch (error) {
       console.error('检查登录缓存状态失败:', error);
       return false;
     }
   },
   
   validateCachedInfo() {
     try {
       const cacheData = this.getLoginInfo();
       if (!cacheData) return false;
       
       // 验证必要字段
       return (
         !!cacheData.userid && 
         !!cacheData.primitiveUserid &&
         cacheData.origin === window.top.location.origin
       );
     } catch (error) {
       console.error('验证登录缓存失败:', error);
       return false;
     }
   },
   
   hasExpiredButExistingCache() {
     try {
       // 检查是否存在缓存数据，不论是否过期
       const cacheDataStr = util.localStorage.get(this.LOGIN_INFO_KEY);
       if (!cacheDataStr) return false;
       
       const cacheTimeStr = util.localStorage.get(this.LOGIN_INFO_TIME_KEY);
       if (!cacheTimeStr) return false;
       
       const cacheTime = parseInt(cacheTimeStr);
       const now = Date.now();
       
       // 如果已过期但数据存在，返回true
       return now - cacheTime > this.CACHE_DURATION;
     } catch (error) {
       console.error('检查过期缓存失败:', error);
       return false;
     }
   },
   
   getExpiredCacheInfo() {
     try {
       const cacheDataStr = util.localStorage.get(this.LOGIN_INFO_KEY);
       if (!cacheDataStr) return null;
       
       return JSON.parse(cacheDataStr);
     } catch (error) {
       console.error('获取过期缓存数据失败:', error);
       return null;
     }
   },
   
   renewCache() {
     try {
       // 获取当前缓存数据
       const cacheDataStr = util.localStorage.get(this.LOGIN_INFO_KEY);
       if (!cacheDataStr) return false;
       
       // 更新时间戳（续期15天）
       util.localStorage.set(this.LOGIN_INFO_TIME_KEY, Date.now().toString());
       console.log('登录信息已续期15天');
       return true;
     } catch (error) {
       console.error('缓存续期失败:', error);
       return false;
     }
   },
};

// 将userLoginCache添加到util对象中
util.userLoginCache = userLoginCache;

export default util
